


















// Components
import downloadApp from '@webapp/components/download-app/download-app.vue';

// Helpers
import {
    generateRandomNumberInRange,
} from '@webapp/helpers/generic';

export default {
    components: {
        downloadApp,
    },
    computed: {
        imageVariant(): number {
            return generateRandomNumberInRange(1, 3);
        },
    },
};
